import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const NotificationsContainer = styled.div`
  position: relative;
  i.left-side-icon {
    &.pressed,
    &:hover {
      background-color: ${Variables.colors.complementary_300};
    }
  }
`;

export const PromoCodeRow = styled.div`
  border-radius: 8px;
  border: 1px solid ${Variables.colors.complementary_400};
  padding: 10px 12px;
  box-shadow: 0 1px 4px 0 #ccc;
  margin: 8px 0;
  width: 100%;
  .inner-container {
    display: flex;
    flex-direction: column;
    .promoCodeLabel {
      cursor: pointer;
      width: 80%;
      margin: 0 auto;
      height: 36px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 35px;
      position: relative;
      box-sizing: border-box;
      background-color: ${Variables.colors.primary};
      color: ${Variables.colors.complementary};
      i {
        position: absolute;
        right: 16px;
        &:before {
          color: ${Variables.colors.complementary};
          font-size: ${Variables.font_sizes.x2_medium};
        }
      }
    }
    .promoText {
      margin: 12px 0;
      width: 100%;
      .main-text {
        color: ${Variables.colors.complementary_900};
        font-size: ${Variables.font_sizes.x_medium};
        line-height: 1.56;
        margin-bottom: 4px;
      }
      .description {
        color: ${Variables.colors.complementary_700};
        font-size: ${Variables.font_sizes.x_small};
      }
    }
  }
`;
